import React from 'react';
import { useNavigate } from 'react-router';
import { Dropdown, Form, FormLabel, Layout } from '@axiom/ui';
import { SORT_BY_OPTIONS } from '@axiom/const';
import { TalentSearchSortingSchema } from '@axiom/validation';
import type { TalentSearchDisplayFilters } from '@axiom/validation';

import type { TalentSearchActiveQueryFilters } from '../../schema/talent-search-active-query-filters';
import { WindowUtil } from '../../utils/window-util';
import { CandidateApi } from '../../api/candidate-api';

const removedSortCriteria = new Set([
  'hourlyRateLowToHigh',
  'hourlyRateHighToLow',
]);
const filteredSortOptions = SORT_BY_OPTIONS.filter(
  option => !removedSortCriteria.has(option.value)
);

export type TalentSearchSortByProps = {
  filters: TalentSearchDisplayFilters;
  activeFilters: TalentSearchActiveQueryFilters;
  disabled?: boolean;
};

export const TalentSearchSortBy = ({
  filters,
  disabled = false,
  activeFilters,
}: TalentSearchSortByProps) => {
  const navigate = useNavigate();
  return (
    <Form
      name="TALENT_SEARCH_SORT_BY"
      schema={TalentSearchSortingSchema}
      submitOnChange
      initialValues={{
        sortBy: filters.sort ?? 'relevance',
      }}
      onSubmit={async changedData => {
        const { sortBy } = changedData;
        void navigate('/browse-talent/page/1');
        WindowUtil.setUrlQuery(
          {
            ...activeFilters,
            sort: sortBy || 'relevance',
          },
          true
        );
        await CandidateApi.refreshCandidateSearchResults();
      }}
    >
      {() => {
        return (
          <Layout
            position="center middle"
            direction="horizontal"
            horizontalGutter="8px"
          >
            <FormLabel name="TALENT_SEARCH_LABEL" for="sortBy">
              Sort by
            </FormLabel>
            <Dropdown
              placeholder={filteredSortOptions[0]?.label}
              options={filteredSortOptions}
              name="sortBy"
              displayKey="label"
              valueKey="value"
              disabled={disabled}
            />
          </Layout>
        );
      }}
    </Form>
  );
};
